module.exports = __webpack_public_path__ + "img/imgyud.fa0e3ecd.jpg";